import { Layout, List, Popover } from 'antd/lib';
import React, { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import {
  onChangeEmployeePosition,
  onGetInstance,
  switchLanguage,
  toggleCollapsedSideNav,
} from '../../appRedux/actions';
import { onGetReminder } from '../../appRedux/actions/Reminder';
import AppModuleHeader from '../../components/AppModuleHeader/index';
import NewChats from '../../components/Chat/NewChats';
import FetchImage from '../../components/FetchData/FetchImage';
import SearchBox from '../../components/SearchBox';
import ToDoListForNotification from '../../components/Todo/ToDoList/ToDoListForNotification';
import { ThemeSetting } from '../../constants/ThemeSetting';
import AuthContext from '../../contexts/AuthContext';
import { ShowError } from '../../helper/Alert';
import { IInstancePrarams } from '../../interfaces/Instance';
import { getLocaleMsg } from '../../lngProvider';
import Auxiliary from '../../util/Auxiliary';
import IntlMessages from '../../util/IntlMessages';
// import languageData from './languageData';

const { NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE } =
  ThemeSetting;

const { Header } = Layout;

const queryString = require('query-string');

const Topbar = () => {
  const intl = useIntl();

  const { locale, width, navStyle } = useSelector(
    ({ settings }: any) => settings,
  );
  const { navCollapsed } = useSelector(({ sideNav }: any) => sideNav);
  const [showMenu, setShowMenu] = useState(false);
  const [user, setUser] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [pageIndex, setPageIndex] = useState(0);
  const [showReminderNotify, setShowReminderNotify] = useState(false);
  const [rootName, setRootName] = useState('topbar.NoTitle');

  const dispatch = useDispatch();

  // const languageMenu = () => (
  //   <ul className="gx-sub-popover">
  //     {languageData.map((language) => (
  //       <li
  //         className="gx-media gx-pointer"
  //         key={JSON.stringify(language)}
  //         onClick={(e) => {
  //           localStorage.setItem(
  //             'language',
  //             language.locale === 'fa' ? 'fa-IR' : 'en-US',
  //           );
  //           dispatch(switchLanguage(language));
  //         }}
  //       >
  //         <i
  //           style={{ width: '25' }}
  //           className={`flag flag-24 gx-mx-2 flag-${language.icon}`}
  //         />
  //         <span className="gx-language-text">{language.name}</span>
  //       </li>
  //     ))}
  //   </ul>
  // );

  const reminderNotify = useSelector(
    ({ reminder }: any) => reminder.reminderNotify,
  );

  const { reminder, sendRequest } = useSelector(
    ({ reminder }: any) => reminder,
  );

  useEffect(() => {
    if (!sendRequest) {
      dispatch(
        onGetReminder({
          page: 0,
          categoryId: 1,
          searchText: null,
          append: false,
          isNotify: true,
        }),
      );
    }
  }, []);

  //********************************** */
  const handleText = (e: any) => {
    const { value } = e.target;
    setSearchText(value);
  };

  const handleEnter = (e: any) => {
    const messages = getLocaleMsg();
    if (e.charCode !== 13) return null;

    if (
      checkVaidate(
        e.target.value,
        'text',
        messages['messages.searchCanNotBeLessThenTreeCharacter'],
        3,
      ) === false
    )
      return null;
    doSearch();
  };

  const handleSearchClicked = () => {
    const messages = getLocaleMsg();
    //---------------------
    const e = document.getElementsByTagName('input');
    if (
      checkVaidate(
        e[0].value,
        'text',
        messages['messages.searchCanNotBeLessThenTreeCharacter'],
        3,
      ) === false
    )
      return null;
    //---------------------
    doSearch();
  };

  const checkVaidate = (
    val: any,
    type: string,
    message: string,
    checkNum?: number,
  ) => {
    switch (type) {
      case 'text':
        {
          if (val.length < (checkNum || 0)) {
            ShowError(message, '');
            return false;
          }
        }
        return true;
      // case "1": {
      // }
      // default: {
      // }
    }
  };

  const doSearch = () => {
    // changeTitle();
    const params: IInstancePrarams = {
      folderCode: 'Search-0',
      pageIndex,
      searchText: searchText,
      folderId: '',
      referTypeId: '',
      ArchivefolderId: '',
    };

    dispatch(onGetInstance(params));
    const route = '/team-work/instance?folder=Search-0';
    history.push(route);
  };

  //********************************** */

  const location = useLocation();
  const qs = queryString.parse(location.search);
  const history = useHistory();

  useEffect(() => {
    const qsPath = location.pathname;
    const strPath = qsPath.split('/');
    const lastWord = strPath[strPath.length - 1];

    switch (lastWord) {
      case 'home':
        {
          setRootName('topbar.NoTitle');
        }
        break;
      case 'instance':
        {
          setRootName('sidebar.Cartable');
        }
        break;
      case 'news':
        {
          setRootName('sidebar.LastNews');
        }
        break;
      case 'chat':
        {
          setRootName('sidebar.Messages');
        }
        break;
      case 'todo':
        {
          setRootName('sidebar.todoApp');
        }
        break;
      case 'notes':
        {
          setRootName('sidebar.Note');
        }
        break;
      case 'calendar':
        {
          setRootName('sidebar.Calendar');
        }
        break;
      case 'contacts':
        {
          setRootName('sidebar.Contacts');
        }
        break;
      default:
        return;
    }

    // dispatch(
    //   onGetReminder({
    //     page: 0,
    //     onlyApproved: false,
    //     onlyforce: true,
    //     searchText: null,
    //     append: false,
    //     isNotify: true,
    //   })
    // );
  }, [location]);

  const pageIndexReset = () => { };
  const onSortEnd = ({ oldIndex, newIndex }: any) => { };
  const onMarkAsStart = (data: any) => { };
  const onTodoSelect = (todo: any) => { };
  const onTodoChecked = (data: any) => { };

  const authContext = useContext(AuthContext);

  function changeHandler(item: any) {
    // TopBar
    if (authContext.setUserEmployeePosition) {
      authContext.setUserEmployeePosition(item);
      dispatch(onChangeEmployeePosition());
      dispatch(toggleCollapsedSideNav(false));
      setShowMenu(false);

      return history.push('/team-work/home');
    }
  }
  const refreshAppointment = (
    pageNum: number,
    onlyAppend: boolean,
    categoryId: number,
  ) => {
    dispatch(
      onGetReminder({
        page: pageNum,
        categoryId: categoryId,
        searchText: null,
        append: onlyAppend,
        isNotify: true,
      }),
    );
  };
  const userMenuOptions = (
    <List
      itemLayout="horizontal"
      dataSource={authContext.userRoles}
      renderItem={(item, index) => (
        <React.Fragment>
          <List.Item key={index} className="gx-pl-5" style={{ width: '242px' }}>
            <List.Item.Meta
              avatar={false}
              title={
                <span
                  onClick={() => changeHandler(item)}
                  className="gx-fs-sm gx-text-primary gx-pointer"
                >
                  {item.fullName}
                  {authContext.userEmployeePosition.personCode ===
                    item.personCode && (
                      <img
                        src={require('../../assets/images/LetterBody/tick.svg')}
                        alt="user-employee-position"
                        style={{ width: '14px' }}
                        className="gx-mx-2 gx-pointer"
                      />
                    )}
                </span>
              }
              description={
                <div onClick={() => changeHandler(item)} className="gx-pointer">
                  <span className="gx-text-orange"> [</span>
                  <span className="gx-fs-sm">{item.organizationName}</span>
                  <span className="gx-text-orange">] </span>
                </div>
              }
            />
          </List.Item>
        </React.Fragment>
      )}
      footer={
        <Link to="/auth/logout">
          <span className="gx-fs-sm">
            <IntlMessages id="topbar.Exit" />
          </span>
        </Link>
      }
    />
  );

  return (
    <Header className="gx-px-1">
      {/* <div className="gx-d-flex gx-flex-column gx-justify-content-start gx-align-items-right"> */}
      {navStyle === NAV_STYLE_DRAWER ||
        ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) &&
          width < TAB_SIZE) ? (
        <div className="gx-linebar gx-mx-2">
          <i
            className="gx-icon-btn icon icon-menu"
            onClick={() => {
              dispatch(toggleCollapsedSideNav(!navCollapsed));
            }}
          />
        </div>
      ) : null}
      <span
        style={{ position: 'absolute', maxWidth: 150 }}
        className={`${locale.direction === 'rtl' ? 'gx-mr-5' : 'gx-ml-5'}`}
      >
        {/* {mainFolders.find((item) => item.handle === qs.folder)?.title} */}
        <IntlMessages id={rootName} />
      </span>

      <ul className="gx-header-notifications gx-ml-auto ">
        {
          // path === "instance"
          true && (
            <>
              <SearchBox
                dir="rtl"
                styleName="gx-d-none gx-d-lg-block gx-lt-icon-search-bar-lg"
                placeholder={
                  intl.formatMessage({ id: 'appPublicWord.search' }) + `...`
                }
                onChange={handleText}
                onKeyPress={handleEnter}
                value={searchText}
              />
              <li className="gx-notify gx-notify-search gx-d-inline-block gx-d-lg-none">
                <Popover
                  overlayClassName="gx-popover-horizantal"
                  placement="bottomRight"
                  content={
                    <AppModuleHeader
                      placeholder={
                        intl.formatMessage({ id: 'appPublicWord.search' }) +
                        `...`
                      }
                      user={user}
                      onChange={handleText}
                      onKeyPress={handleEnter}
                      onSearchClick={handleSearchClicked}
                      onClearText={() => setSearchText('')}
                      value={searchText}
                    />
                  }
                  trigger="click"
                >
                  <span
                    className="gx-pointer gx-d-block"
                    onClick={() => {
                      setSearchText('');
                    }}
                  >
                    <i className="icon icon-search-new" />
                  </span>
                </Popover>
              </li>
              {width >= TAB_SIZE ? null : (
                <Auxiliary>
                  {(reminder || reminderNotify) &&
                    (reminderNotify.pendingItems.length > 0 ||
                      reminderNotify.doneItems.length > 0 ||
                      reminderNotify.reminderItems.length > 0 ||
                      reminderNotify.archiveItems.length > 0 ||
                      reminderNotify.noteItems.length > 0 ||
                      reminder.pendingItems.length > 0 ||
                      reminder.doneItems.length > 0 ||
                      reminder.reminderItems.length > 0 ||
                      reminder.archiveItems.length > 0 ||
                      reminder.noteItems.length > 0) &&
                    (
                      < li
                        className="gx-notify"
                        onClick={() => {
                          dispatch(
                            onGetReminder({
                              page: 0,
                              categoryId: 1,
                              searchText: null,
                              append: false,
                              isNotify: true,
                            }),
                          );
                        }}
                      >
                        <Popover
                          visible={showReminderNotify}
                          onVisibleChange={(val: boolean) => {
                            setShowReminderNotify(val);
                          }}
                          overlayClassName="gx-popover-horizantal"
                          placement="bottomRight"
                          content={
                            showReminderNotify && (
                              <ToDoListForNotification
                                refreshNotify={refreshAppointment}
                                toDos={reminderNotify}
                                pageIndexReset={pageIndexReset}
                                onSortEnd={onSortEnd}
                                onMarkAsStart={(e: any) => onMarkAsStart(e)}
                                onTodoSelect={(e: any) => onTodoSelect(e)}
                                onTodoChecked={(e: any) => onTodoChecked(e)}
                                useDragHandle={false}
                              />
                            )
                          }
                          trigger="click"
                        >
                          <span
                            onClick={() => {
                              setShowReminderNotify(true);
                            }}
                            className="gx-pointer gx-status-pos gx-d-block"
                          >
                            <i className="icon icon-notification" />

                            <span className="gx-status gx-status-rtl gx-small gx-orange" />
                          </span>
                        </Popover>
                      </li>
                    )}
                  <NewChats />
                </Auxiliary>
              )}
            </>
          )
        }

        {/* <li className="gx-language gx-mx-2">
          <Popover
            style={{ height: "200px !important" }}
            overlayClassName="gx-popover-horizantal"
            placement="bottomRight"
            content={languageMenu()}
            trigger="click"
          >
            <span className="gx-pointer gx-flex-row gx-align-items-center">
              <i
                style={{ width: "25px" }}
                className={`flag flag-24 flag-${locale.icon}`}
              />
              <span className="gx-pl-2 gx-pr-2 gx-language-name">
                {locale.name}
              </span>
              <i className="icon icon-chevron-down gx-pl-2" />
            </span>
          </Popover>
        </li> */}

        {width >= TAB_SIZE ? null : (
          <li className="gx-user-nav gx-mx-2">
            <Popover
              visible={showMenu}
              onVisibleChange={(val) => setShowMenu(val)}
              overlayClassName="gx-popover-horizantal"
              placement="bottomRight"
              content={userMenuOptions}
              trigger="click"
            >
              <span className="gx-pointer gx-flex-row gx-align-items-center">
                <FetchImage
                  src={`contactPicture/getContactPicture?img=true`}
                  className="gx-rounded-circle gx-size-30"
                />
              </span>
            </Popover>
          </li>
        )}
      </ul>
      {/* </div> */}
    </Header >
  );
};

export default Topbar;
